<template lang="pug">
  .avatar-cropper
    .image-cropper
      vue-croppie(
        ref="imageCropper"
        :enableOrientation="false"
        :enableResize="false"
        :viewport="{ width: 250, height: 250, type: 'circle' }"
        :boundary="{ width: 275, height: 275 }"
        @result="result"
        @update="update"
      )
    .upload-area(style="margin-left: 20px;")
      b-field(class="file")
        b-upload(v-model="files" @input="updateImage" accept="image/*")
          a.button.is-outlined
            span.icon
              svgicon(icon="arrow-download" class="has-text-success" width="14" height="17")
            span Parcourir
      vue-progress-bar(v-if="avatarWasSent")
      .progress-bar-message(v-if="avatarWasSent") En cours d'importation
      .success-import-message(v-if="avatarWasSuccessfullyUpdated")
        svgicon(icon="tick" class="has-text-success" width="20" height="20" color="#2DCCAC")
        | Photo de profil importée avec succès !
      .legend Formats acceptés : PNG / JPG
      .legend Dimension : 370x370px min.
      .legend Poids : 4 Mo max
</template>

<script>
  // import Vue from 'vue'
  import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
  import _ from 'lodash'

  @Component({
    components: {

    }
  })
  export default class AvatarCropper extends Vue {
    cropped = null
    files = null
    imageSuccessfullyUploaded = false

    mounted() {
      this.$refs.imageCropper.bind({
        url: this.imageUrl || 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
      })
    }

    @Prop({ default: null})
    imageUrl

    @Prop({ default: 1 })
    crop

    @Prop({ default: false })
    avatarWasSent
    @Watch('avatarWasSent')
    startProgressBar() {
      if (this.avatarWasSent === true) {
        this.$Progress.start()
      }
    }

    @Prop({ default: false })
    avatarWasSuccessfullyUpdated
    @Watch('avatarWasSuccessfullyUpdated')
    stopProgressBar() {
      if (this.avatarWasSuccessfullyUpdated === true) {
        this.$Progress.finish()
      }
    }

    @Watch('crop')
    fireCrop(crop) {
      if (crop && (this.files || this.imageUrl)) {
        this.cropImage()
      }
    }

    cropImage() {
      const options = {
        format: 'base64',
        circle: false,
        size: { width: 500, height: 500 }
      }
      this.$refs.imageCropper.result(options, (output) => {
        this.cropped = output
        this.$emit('crop', this.cropped)
      });
    }

    result(output) {
      this.cropped = output
    }

    update = _.debounce( (val) => {
      this.cropImage()
    }, 500)

    updateImage(files) {
      const file = files
      const reader = new FileReader()

      reader.addEventListener('load', () => {
        this.$refs.imageCropper.bind({
          url: reader.result
        })
      })
      if (file && /\.(jpe?g|png)$/i.test( file.name )) {
        reader.readAsDataURL( file )
      }
    }
  }
</script>
